/** @format */
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: `button[homefield-text-link]`,
  templateUrl: './text-link.component.html',
  styleUrl: './text-link.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldTextLinkComponent {
  public LinkTargets = {
    blank: '_blank',
    self: '_self',
    parent: '_parent',
    top: '_top',
  };

  @Input() public icon = '';
  @Input() public styled = false;
  @Input() public iconPlacement = 'left';
  @Input() public target: keyof typeof this.LinkTargets = 'self';
  @HostBinding('attr.aria-label') @Input() ariaLabel = null;
  @HostBinding('attr.alt') @Input() altText = null;
  @HostBinding('attr.data-em') @Input() dataEm = null;
  @HostBinding('attr.href') @Input() linkURL = '';
  @HostBinding('class') @Input() classList = '';

  @HostBinding('class') get getVariantApplication() {
    return `${this.classList}${this.classList ? ' ' : ''}${this.getAdditionalCssClass(
      this.iconPlacement,
      this.styled,
    )}`;
  }

  @HostBinding('attr.target') get geTarget() {
    return this.LinkTargets[this.target];
  }

  getAdditionalCssClass(iconPlacement: string, styled = false) {
    let additionalClasses = '';
    additionalClasses =
      iconPlacement === 'right' ? `${additionalClasses} icon-right` : additionalClasses;
    additionalClasses = styled ? `${additionalClasses} styled` : additionalClasses;
    return `homefield-text-link${additionalClasses}`;
  }
}
